var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C11.4477 18 11 17.5523 11 17V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V17C13 17.5523 12.5523 18 12 18Z",
    fill: "#009788"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12Z",
    fill: "#009788"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90765 2.77024C7.70434 2.31244 7.90602 1.77411 8.37904 1.60927C8.85206 1.44443 9.35196 1.73896 9.47682 2.22407L9.56456 2.56499C9.66657 2.96131 9.42363 3.36322 9.03718 3.49788C8.65074 3.63254 8.21661 3.46598 8.05052 3.09197L7.90765 2.77024ZM3.19534 7.25394C2.70939 6.9915 2.52452 6.38178 2.83001 5.92168C3.13018 5.46958 3.46284 5.04105 3.82463 4.6394C4.19426 4.22905 4.83081 4.25608 5.20612 4.66125C5.58143 5.06642 5.55237 5.69584 5.191 6.11349C4.98021 6.35712 4.7823 6.61213 4.59832 6.87746C4.28361 7.33131 3.68128 7.51639 3.19534 7.25394ZM1 11.9991C1 11.7265 1.00994 11.456 1.02949 11.1881C1.06968 10.6373 1.58905 10.2683 2.13396 10.3583C2.67887 10.4482 3.04198 10.9632 3.01278 11.5148C3.0043 11.6751 3 11.8365 3 11.9991C3 12.1617 3.0043 12.3232 3.01278 12.4834C3.04198 13.035 2.67887 13.55 2.13396 13.64C1.58905 13.7299 1.06968 13.3609 1.02949 12.8101C1.00994 12.5422 1 12.2717 1 11.9991ZM5.20615 19.3369C4.83083 19.7421 4.19424 19.7691 3.82459 19.3588C3.46282 18.9571 3.13018 18.5286 2.83002 18.0766C2.52452 17.6165 2.7094 17.0067 3.19535 16.7443C3.68129 16.4819 4.28361 16.6669 4.59832 17.1208C4.78231 17.3861 4.98023 17.6411 5.19102 17.8847C5.55238 18.3023 5.58144 18.9317 5.20615 19.3369ZM9.4768 21.7742C9.35195 22.2593 8.85209 22.5538 8.3791 22.389C7.90607 22.2241 7.70435 21.6857 7.90766 21.2279L8.05049 20.9063C8.21659 20.5322 8.65077 20.3657 9.03724 20.5003C9.42366 20.635 9.66658 21.0369 9.56458 21.4331L9.4768 21.7742Z",
    fill: "#009788"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C21 7.3669 17.4991 3.55146 12.9984 3.05475C12.4494 2.99417 12 2.55228 12 2C12 1.44772 12.4492 0.995245 12.9993 1.04478C18.6061 1.54966 23 6.26171 23 12C23 17.7383 18.6061 22.4503 12.9993 22.9552C12.4492 23.0048 12 22.5523 12 22C12 21.4477 12.4494 21.0058 12.9984 20.9452C17.4991 20.4485 21 16.6331 21 12Z",
    fill: "#009788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.3cec64ed69c966376a267eb1f5a593b4.svg";
export { ForwardRef as ReactComponent };